
import React from 'react';

const EmailSection = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4">C. Contact by email</h2>
      <div className="space-y-4">
        <p className="text-gray-600">
          You have the option to contact us by email. You are solely responsible for the information and/or content you send us. We recommend that you do not transmit confidential data. Personal data is only collected by us if you voluntarily provide it to us. Therefore, you are solely responsible for the data you transmit to us. In order to answer your questions, we may ask you for additional information such as your address, telephone number, etc. We only collect personal data from you if it is necessary to answer your questions or provide the services you have requested.
        </p>
        <p className="text-gray-600">
          When processing your email request, our legitimate interest in data processing pursuant to Art. 6 para. 1 let. f EU-GDPR exists. You can object to this data processing at any time.
        </p>
      </div>
    </section>
  );
};

export default EmailSection;
